<script lang="ts">
	import { Button } from '$lib/components/ui/button/index.js';
	import * as Dialog from '$lib/components/ui/dialog/index.js';
	import { localizeHref } from '@/paraglide/runtime';
	import { loginModalStore } from '@/stores/LoginModalStore.svelte';
</script>

<Dialog.Root bind:open={loginModalStore.visibility}>
	<Dialog.Content class="sm:max-w-[425px]">
		<Dialog.Header>
			<Dialog.Title>Inicia sesión o crea una cuenta</Dialog.Title>
			<Dialog.Description>
				Necesitas iniciar sesión o crear una cuenta para continuar.
			</Dialog.Description>
		</Dialog.Header>
		<Dialog.Footer>
			<div class="flex w-full items-center justify-center gap-2">
				<Button
					href={localizeHref('/iniciar-sesion')}
					onclick={() => (loginModalStore.visibility = false)}
					variant="default">Iniciar sesión</Button
				>
				<Button
					href={localizeHref('/registro')}
					onclick={() => (loginModalStore.visibility = false)}
					variant="outline">Crear cuenta</Button
				>
			</div>
		</Dialog.Footer>
	</Dialog.Content>
</Dialog.Root>
